<div class="card mb-2">
    <div class="card-body">
        <div>
            <button class="btn btn-primary float-right pointer" routerLink="/ticket-types/new">Create new Ticket
                Type</button>
            <h2>Ticket Types</h2>
            <div class="custom-control custom-switch mb-3">
                <input type="checkbox" class="custom-control-input" id="showArchivedTicketTypes"
                    [(ngModel)]="showArchived" (ngModelChange)="reloadList()" [disabled]="saving || !!archiveConfirmation">
                <label class="custom-control-label" for="showArchivedTicketTypes">Show archived ticket types</label>
            </div>
            
            <i *ngIf="loading" class="material-icons rotate text-muted">loop</i>
            <p-table #myTable *ngIf="!loading" [value]="ticketTypes" 
            [paginator]="true" [rows]="10" 
            [responsive]="true" [resizableColumns]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th pResizableColumn></th>
                        <th pResizableColumn>Id</th>
                        <th pResizableColumn>Name</th>
                        <th pResizableColumn>Status</th>
                        <th pResizableColumn>Custom Fields</th>
                        <th pResizableColumn>Ticket Statuses</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-ticketType>
                    <tr>
                        <td> <button class="btn btn-primary" [disabled]="saving" (click)="editTicketType(ticketType.id)">Edit</button>
                            <button type="button" class="btn ml-2" [class.btn-outline-danger]="!ticketType.archivedDate"
                                [class.btn-outline-primary]="!!ticketType.archivedDate" *ngIf="ticketType.canDeleteTypes"
                                [disabled]="saving || !!archiveConfirmation" (click)="setArchivedStatus(ticketType)">
                                {{ ticketType.archivedDate ? 'Unarchive' : 'Archive' }}
                            </button>
                        </td>
                        <td>{{ ticketType.id }}</td>
                        <td>{{ ticketType.name }}</td>
                        <td>{{ ticketType.archivedDate ? 'Archived' : 'Active' }}</td>
                        <td>
                            <ul>
                                <li *ngFor="let field of getCustomFields(ticketType)">
                                    {{ field.name }}
                                </li>
                            </ul>
                        </td>
                        <td>
                            <ul>
                                <li *ngFor="let status of ticketType.ticketStatuses">
                                    {{ status.name }}
                                </li>
                            </ul>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="6">No ticket types found.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="paginatorleft" let-state>
                    Showing {{ state.first + 1 }} - {{ (state.first + state.rows) > state.totalRecords ? state.totalRecords : (state.first + state.rows) }} of {{ state.totalRecords }} entries
                </ng-template>
                <ng-template pTemplate="paginatorright">
                        <div style="display: flex; align-items: center; gap: 0.5rem;">
                            <span style="color: #495057; font-size: 14px; white-space: nowrap;">Rows per page:</span>
                            <p-dropdown 
                                [options]="dropdownOptions()" 
                                optionLabel="label" 
                                optionValue="value"
                                [ngModel]="myTable.rows" 
                                (onChange)="myTable.rows = $event.value; myTable.reset()">
                            </p-dropdown>
                        </div>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
